import React, { Component } from 'react'
import axios from 'axios'
import Loader from '../../components/Loader/Loader.jsx'
export default class Quotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: '',
      author: '',
      quote: '',
    }
  }
  componentDidMount = () => {
    axios
      .get(
        'https://wt-566da441a4b59d2631369d6ab2777d69-0.sandbox.auth0-extend.com/randomeQuote'
      )
      .then(res => {
        const { data } = res
        this.setState({
          author: data[0].author,
          quote: data[0].body,
          loading: false,
        })
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: 'there is an error loading the quote',
        })
      })
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <Loader />
        ) : (
          <blockquote>
            {`"${this.state.quote}" - ${this.state.author}`}
          </blockquote>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Quotes/Quotes.jsx